<style scoped lang="scss"></style>

<template>
  <div>
    <div>
      <v-button @click.native="createPostback()" class="btn btn-primary"
        >Erstellen</v-button
      >
    </div>
    <div>
      <v-table
        url="/api/v1/postback"
        :attributes="[
          {
            attribute: 'id',
            name: 'Postback-ID'
          },
          {
            attribute: 'affiliate_id',
            name: 'Werbung-ID'
          },
          {
            attribute: 'trigger_event',
            name: 'Trigger Event'
          },
          {
            attribute: 'type',
            name: 'Type'
          },
          {
            name: 'Aktionen',
            type: 'PostbackActionCell'
          }
        ]"
      >
        <div slot="title">
          <h4>Postbacks</h4>
        </div>
      </v-table>
    </div>
  </div>
</template>

<script lang="babel">
export default {
  methods: {
    createPostback(){
      this.$router.push('/werbungsverfolgung/erstellen');
    }
  }
}
</script>
